// src/modules/SortMenu.jsx
import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";

const DEFAULT_OPTIONS = [
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
  { value: "titleAZ", label: "Title A–Z" },
  { value: "titleZA", label: "Title Z–A" },
  { value: "numberAsc", label: "Hymn # Asc" },
  { value: "numberDesc", label: "Hymn # Desc" },
];

export default function SortMenu({
  value,
  onChange,
  options,
  sx,
  label = "Sort",
}) {
  // Always fall back to a safe array
  const opts = Array.isArray(options) && options.length > 0
    ? options
    : DEFAULT_OPTIONS;

  // If no value provided, default to first option
  const current = value ?? opts[0].value;

  const handleChange = (e) => onChange?.(e.target.value);

  return (
    <Box sx={sx}>
      <FormControl size="small" sx={{ minWidth: 190 }}>
        <InputLabel id="sort-select-label">
          <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
            <SortIcon fontSize="small" /> {label}
          </Box>
        </InputLabel>
        <Select
          labelId="sort-select-label"
          label={label}
          value={current}
          onChange={handleChange}
        >
          {opts.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
